export const url = 'https://anahit.ai/';
export const superset_password = "admin@123";
export const superset_username = "anahit_admin";
export const superset_first_name = "anahit";
export const superset_last_name = "anahit";
export const superset_domain = "https://analytics.anahit.ai/";
